/* 商品カードのホバー背景: MVと共通の背景パターン(wooly-pattern--1/2/3)をランダム割り当て */
(() => {
  const PATTERNS = 3;

  function decorate(card) {
    if (!card || card.dataset.cardPattern) return;
    card.dataset.cardPattern = 'true';
    const bg = document.createElement('span');
    const n = 1 + Math.floor(Math.random() * PATTERNS);
    bg.className = 'card-hover-bg wooly-pattern--' + n;
    bg.setAttribute('aria-hidden', 'true');
    card.insertBefore(bg, card.firstChild);
  }

  function scan(root) {
    (root || document).querySelectorAll('.card-wrapper.product-card-wrapper').forEach(decorate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scan());
  } else {
    scan();
  }

  // フィルター/ページネーション等でAJAX追加されたカードにも適用
  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.matches && node.matches('.card-wrapper.product-card-wrapper')) {
          decorate(node);
        } else if (node.querySelectorAll) {
          scan(node);
        }
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
